module.exports = __webpack_public_path__ + "static/logo-f5b11dd3a458461d2060b23f8a4ad837.png";